module.exports = __webpack_public_path__ + "images/emoji/briefcase.9305fd70c12aa96b1876.png";